import { render, staticRenderFns } from "./GeodirMapPrincipal.vue?vue&type=template&id=0f63f5d6"
import script from "./GeodirMapPrincipal.vue?vue&type=script&lang=js"
export * from "./GeodirMapPrincipal.vue?vue&type=script&lang=js"
import style0 from "./GeodirMapPrincipal.vue?vue&type=style&index=0&id=0f63f5d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports